import { Input } from '@builder.io/sdk';

import imageField from 'molecules/Image/config';

const CompanyCardFields = [
  imageField('logo'),
  {
    name: 'companyName',
    type: 'string',
    defaultValue: 'Prismatic',
    helperText: 'The name of the company displayed on the card.',
  },
  {
    name: 'stats',
    type: 'list',
    subFields: [
      {
        name: 'key',
        type: 'string',
        defaultValue: 'Use Case',
        helperText: 'Label for the stat (e.g., “Industry”, “Employees”, “Revenue”).',
      },
      {
        name: 'value',
        type: 'string',
        defaultValue: 'Lorem ipsum',
        helperText: 'Value for the stat (e.g., “SaaS”, “150+”, “$10M ARR”).',
      },
    ],
    helperText: 'Key/value pairs highlighting important company stats or attributes.',
  },
  {
    name: 'description',
    type: 'longText',
    defaultValue:
      'Lorem ipsum odor amet, consectetuer adipiscing elit. Fringilla curae enim quam dolor risus justo neque. Penatibus blandit risus, natoque placerat lobortis nostra. Dis parturient ipsum parturient sollicitudin morbi commodo conubia.',
    helperText: 'Short description or overview of the company. Keep it concise and informative.',
  },
  {
    name: 'button',
    type: 'object',
    helperText: 'Optional CTA button for contacting the partner (e.g., “Contact partner”).',
    subFields: [
      {
        name: 'label',
        type: 'string',
        defaultValue: 'Contact partner',
        helperText: 'Text shown on the CTA button.',
      },
      {
        name: 'url',
        type: 'url',
        defaultValue: 'https://prismatic.io/contact',
        helperText: 'Link used for the CTA button.',
      },
    ],
  },
] as const satisfies DeepReadonly<Input[]>;

const companyCardConfig = {
  name: 'Company Card',
  inputs: CompanyCardFields,
};

export type CompanyCardFields = GenerateBuilder<typeof CompanyCardFields>;

export default companyCardConfig;
